// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"ca2a252d","453":"e43843c6"}[chunkId] + ".chunk.js";
};